var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServeFoodCourts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23408 0H43.7656L48.8141 10.0655V14.79C48.8141 16.4711 48.1442 18.0833 46.9518 19.272C45.7593 20.4608 44.142 21.1286 42.4557 21.1286C40.8876 21.1286 39.3793 20.5512 38.2167 19.5145C37.0541 20.5512 35.5458 21.1286 33.9778 21.1286C32.4097 21.1286 30.9014 20.5512 29.7388 19.5145C28.5762 20.5512 27.0679 21.1286 25.4998 21.1286C23.9318 21.1286 22.4235 20.5512 21.2609 19.5145C20.0983 20.5512 18.59 21.1286 17.0219 21.1286C15.4539 21.1286 13.9455 20.5512 12.783 19.5145C11.6204 20.5512 10.112 21.1286 8.54399 21.1286C6.85762 21.1286 5.24033 20.4608 4.04789 19.272C2.85545 18.0833 2.18555 16.4711 2.18555 14.79V10.0655L7.23408 0ZM10.6635 14.79H14.9024C14.9024 15.3504 15.1257 15.8878 15.5232 16.284C15.9207 16.6803 16.4598 16.9029 17.0219 16.9029C17.584 16.9029 18.1231 16.6803 18.5206 16.284C18.9181 15.8878 19.1414 15.3504 19.1414 14.79H23.3804C23.3804 15.3504 23.6037 15.8878 24.0011 16.284C24.3986 16.6803 24.9377 16.9029 25.4998 16.9029C26.062 16.9029 26.6011 16.6803 26.9985 16.284C27.396 15.8878 27.6193 15.3504 27.6193 14.79H31.8583C31.8583 15.3504 32.0816 15.8878 32.4791 16.284C32.8765 16.6803 33.4156 16.9029 33.9778 16.9029C34.5399 16.9029 35.079 16.6803 35.4765 16.284C35.8739 15.8878 36.0972 15.3504 36.0972 14.79H40.3362C40.3362 15.3504 40.5595 15.8878 40.957 16.284C41.3545 16.6803 41.8936 16.9029 42.4557 16.9029C43.0178 16.9029 43.5569 16.6803 43.9544 16.284C44.3519 15.8878 44.5752 15.3504 44.5752 14.79V11.0631L41.1458 4.22571H9.8539L6.42451 11.0631V14.79C6.42451 15.3504 6.64781 15.8878 7.04529 16.284C7.44277 16.6803 7.98187 16.9029 8.54399 16.9029C9.10611 16.9029 9.64521 16.6803 10.0427 16.284C10.4402 15.8878 10.6635 15.3504 10.6635 14.79Z",
    fill: "#17CE8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5008 32.0277C23.7618 32.0277 22.0939 32.714 20.8642 33.9354C19.6345 35.1569 18.9437 36.8136 18.9437 38.541V38.6433H32.058V38.541C32.058 36.8136 31.3671 35.1569 30.1374 33.9354C28.9077 32.714 27.2399 32.0277 25.5008 32.0277ZM17.7732 30.865C19.8227 28.8292 22.6024 27.6855 25.5008 27.6855C28.3993 27.6855 31.179 28.8292 33.2285 30.865C35.278 32.9009 36.4294 35.662 36.4294 38.541V42.9855H14.5723V38.541C14.5723 35.662 15.7237 32.9009 17.7732 30.865Z",
    fill: "#17CE8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3145 29.8714V25.5H27.6859V29.8714H23.3145Z",
    fill: "#17CE8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8848 42.9857H12.3848V38.6143H37.8848V42.9857Z",
    fill: "#17CE8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 51.0003H0V46.6289H51V51.0003Z",
    fill: "#17CE8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37109 48.8139V17.4854H8.01395V48.8139H4.37109Z",
    fill: "#17CE8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9863 48.8139V17.4854H46.6292V48.8139H42.9863Z",
    fill: "#17CE8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6282 13.1146H4.37109V8.01465H46.6282V13.1146Z",
    fill: "#17CE8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9277 14.5716V10.9287H14.5706V14.5716H10.9277Z",
    fill: "#17CE8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9434 14.5716V10.9287H23.3148V14.5716H18.9434Z",
    fill: "#17CE8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6855 14.5716V10.9287H32.057V14.5716H27.6855Z",
    fill: "#17CE8C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4277 14.5716V10.9287H40.0706V14.5716H36.4277Z",
    fill: "#17CE8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServeFoodCourts);
export default __webpack_public_path__ + "static/media/serve_food_courts.e2daced98386047939855446a9b24498.svg";
export { ForwardRef as ReactComponent };